import { useEffect, useRef, useState } from 'react';
const useTouchMove = () => {
  const [active, setActive] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const noteRef = useRef({ isAdded: false, total: 1 });
  const observerScroll = () => {
    const target = ref.current;
    if (target) {
      const offSetWidth = target.offsetWidth;
      const scrollLeft = target.scrollLeft;
      const active = Math.floor(scrollLeft / offSetWidth);

      setActive(active);
    }
  };
  const changePage = (type: 'next' | 'prev') => {
    const target = ref.current;
    if (target) {
      const scrollLeft = target.scrollLeft;
      const offSetWidth = target.offsetWidth;
      const leftMap = {
        next: scrollLeft + offSetWidth,
        prev: scrollLeft - offSetWidth,
      };
      target.scrollTo({
        left: leftMap[type],
        behavior: 'smooth',
      });
    }
  };

  const onNext = () => {
    if (active >= noteRef.current.total) return;
    changePage('next');
  };
  const onPrev = () => {
    if (active <= 0) return;
    changePage('prev');
  };

  const onReset = () => {
    setActive(0);
    const target = ref.current;
    if (target) {
      target.scrollTo({
        left: 0,
      });
    }
  };

  useEffect(() => {
    const target = ref.current;

    if (target && !noteRef.current.isAdded) {
      target.className +=
        ' w-full flex overflow-x-auto hide-scrollbar snap-x snap-mandatory';
      const childs = target.childNodes as unknown as HTMLDivElement[];
      noteRef.current.total = childs.length;
      childs.forEach((child) => {
        child.className += ' flex-shrink-0 snap-always snap-center w-full';
      });
      noteRef.current.isAdded = true;
    }
    target?.addEventListener('scroll', observerScroll);
    return () => {
      target?.removeEventListener('scroll', observerScroll);
    };
  }, [ref.current]);

  return {
    ref,
    active,
    onNext,
    onPrev,
    onReset,
  };
};
export default useTouchMove;
